"use client";
import { cn } from "@/lib/utils";
import { clientPage } from "@/strings/clients";
import { motion } from "framer-motion";

export function Testimonial({
  testimonial,
  idx,
}: {
  testimonial: (typeof clientPage.testimonials)[number];
  idx: number;
}) {
  return (
    <motion.div
      className={cn(
        idx % 2 === 0 ? "btm-left-in" : "btm-right-in",
        " w-full lg:w-2/3 bg-sima-grey-dark flex flex-col p-8 pb-12 gap-4 rounded-xl relative text-md md:text-lg"
      )}
      key={testimonial.name}
      initial={{ y: 100, opacity: 0 }}
      whileInView={{ y: 0, opacity: 1 }}
      viewport={{ once: true }}
      transition={{
        ease: "easeIn",
        delay: 0,
        duration: 0.2,
      }}
    >
      {testimonial.testimonial.map((para) => (
        <p key={para.split(" ")[0] + idx}>{para}</p>
      ))}
      <div
        className={cn(
          "flex flex-col bg-sima-orange absolute -bottom-12 md:-bottom-8 p-2 max-w-2/3 text-sm md:text-md",
          idx % 2 === 0
            ? "inset-x-4 md:left-auto md:right-6"
            : "inset-x-4 md:left-6 md:right-auto"
        )}
      >
        <p
          className={cn(
            `font-bold md:text-lg`,
            idx % 2 === 0 ? "md:text-right" : "md:text-left"
          )}
        >
          {testimonial.name}
        </p>
        <p
          className={cn(
            " italic",
            idx % 2 === 0 ? "md:text-right" : "md:text-left"
          )}
        >
          {testimonial.position}
        </p>
      </div>
    </motion.div>
  );
}
